import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '../assets/control/showvirtualwall.png'
import _imports_1 from '../assets/control/hidevirtualwall.png'
import _imports_2 from '../assets/control/showfunctionAreas.png'
import _imports_3 from '../assets/control/hidefunctionAreas.png'
import _imports_4 from '../assets/control/showfunctionpoints.png'
import _imports_5 from '../assets/control/hidefunctionpoints.png'


const _hoisted_1 = { class: "controlmapelements" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1
}
const _hoisted_4 = {
  key: 0,
  src: _imports_2
}
const _hoisted_5 = {
  key: 1,
  src: _imports_3
}
const _hoisted_6 = {
  key: 0,
  src: _imports_4
}
const _hoisted_7 = {
  key: 1,
  src: _imports_5
}
const _hoisted_8 = {
  key: 0,
  src: _imports_0
}
const _hoisted_9 = {
  key: 1,
  src: _imports_1
}
const _hoisted_10 = {
  key: 0,
  src: _imports_2
}
const _hoisted_11 = {
  key: 1,
  src: _imports_3
}
const _hoisted_12 = {
  key: 0,
  src: _imports_4
}
const _hoisted_13 = {
  key: 1,
  src: _imports_5
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          class: _normalizeClass({ disable: !_ctx.cusWallEnable }),
          span: 8,
          onClick: _ctx.toggleVirtualWallsMethods
        }, {
          default: _withCtx(() => [
            (_ctx.showvirtualwall)
              ? (_openBlock(), _createElementBlock("img", _hoisted_2))
              : _createCommentVNode("", true),
            (!_ctx.showvirtualwall)
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class", "onClick"]),
        _createVNode(_component_a_col, {
          class: _normalizeClass({ disable: !_ctx.cusAreasEnable }),
          span: 8,
          onClick: _ctx.toggleFunctionAreasMethods
        }, {
          default: _withCtx(() => [
            (_ctx.showfunctionAreas)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : _createCommentVNode("", true),
            (!_ctx.showfunctionAreas)
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class", "onClick"]),
        _createVNode(_component_a_col, {
          class: _normalizeClass({ disable: !_ctx.cusPointsEnable }),
          span: 8,
          onClick: _ctx.toggleFunctionpointsMethods
        }, {
          default: _withCtx(() => [
            (_ctx.showfunctionpoints)
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : _createCommentVNode("", true),
            (!_ctx.showfunctionpoints)
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class", "onClick"])
      ]),
      _: 1
    }, 512), [
      [_vShow, !_ctx.mShowErected]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", {
        class: _normalizeClass({ disable: !_ctx.cusWallEnable }),
        span: 8,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleVirtualWallsMethods && _ctx.toggleVirtualWallsMethods(...args)))
      }, [
        (_ctx.showvirtualwall)
          ? (_openBlock(), _createElementBlock("img", _hoisted_8))
          : _createCommentVNode("", true),
        (!_ctx.showvirtualwall)
          ? (_openBlock(), _createElementBlock("img", _hoisted_9))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({ disable: !_ctx.cusAreasEnable }),
        span: 8,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFunctionAreasMethods && _ctx.toggleFunctionAreasMethods(...args)))
      }, [
        (_ctx.showfunctionAreas)
          ? (_openBlock(), _createElementBlock("img", _hoisted_10))
          : _createCommentVNode("", true),
        (!_ctx.showfunctionAreas)
          ? (_openBlock(), _createElementBlock("img", _hoisted_11))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({ disable: !_ctx.cusPointsEnable }),
        span: 8,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleFunctionpointsMethods && _ctx.toggleFunctionpointsMethods(...args)))
      }, [
        (_ctx.showfunctionpoints)
          ? (_openBlock(), _createElementBlock("img", _hoisted_12))
          : _createCommentVNode("", true),
        (!_ctx.showfunctionpoints)
          ? (_openBlock(), _createElementBlock("img", _hoisted_13))
          : _createCommentVNode("", true)
      ], 2)
    ], 512), [
      [_vShow, _ctx.mShowErected]
    ])
  ]))
}